import {createAction} from 'web-app/util/redux/typed-action-helpers';

const domain = 'MODALS/DRAFT_MANAGER';

type InitialValues = {
    richTextBody: string | null;
    selectedRecipients: string | null;
    from: string | null;
};

export const {action: showWithInitialValues} = createAction(
    `${domain}/SHOW_WITH_INITIAL_VALUES`,
    (initialValues: InitialValues) => initialValues,
);
